// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3faNE","image":"Header_image__1dIgX","name":"Header_name__eqSKZ","info":"Header_info__nFvKB","infoRow":"Header_infoRow__1rSSw"};